import { IRentingInfo, BankName } from '../tools/api.service';

export class RentingInfo {
  rentingID: number;
  companyID: number;
  leader: string;
  bodyshopInterlocutor: string;
  ctcID: number;
  companyPhone: string;
  companyMail: string;
  companyDirectLign: string;
  customerStatus: string;
  technology: string;
  ixellAccount: string;
  companyType: string;
  companyTypeName: string;
  rentingDuration: number;
  status: number;
  isChecked: number;
  sageCode: string;
  bank: BankName;
  invoiceCode: string;
  rentingDate: string;
  treatmentDate: string;
  companyUnisiteCode: string;
  companySocialReason: string;
  companyAddress: string;
  companyPostalCode: string;
  companyCity: string;
  companyCountry: string;
  companySiren: string;
  ctcFirstname: string;
  ctcName: string;
  ctcPhone: string;
  ctcMail: string;
  ctcLanguage: string;
      
  public static parseToRentingInfo(item: IRentingInfo): RentingInfo {
    let result = new RentingInfo();
    result.rentingID = item.rentingID;
    result.companyID = item.companyID;
    result.leader = item.leader;
    result.bodyshopInterlocutor = item.bodyshopInterlocutor;
    result.ctcID = item.ctcID;
    result.companyPhone = item.companyPhone;
    result.companyMail = item.companyMail;
    result.companyDirectLign = item.companyDirectLign;
    result.customerStatus = item.customerStatus;
    result.technology = item.technology;
    result.ixellAccount = item.ixellAccount;
    result.companyType = item.companyType;
    result.companyTypeName = item.companyTypeName;
    result.rentingDuration = item.rentingDuration;
    result.status = item.status;
    result.isChecked = item.isChecked;
    result.sageCode = item.sageCode;
    result.bank = item.bank;
    result.invoiceCode = item.invoiceCode;
    result.rentingDate = item.rentingDate;
    result.treatmentDate = item.treatmentDate;
    result.companyUnisiteCode = item.companyUnisiteCode;
    result.companySocialReason = item.companySocialReason;
    result.companyAddress = item.companyAddress;
    result.companyPostalCode = item.companyPostalCode;
    result.companyCity = item.companyCity;
    result.companyCountry = item.companyCountry;
    result.companySiren = item.companySiren;
    result.ctcFirstname = item.ctcFirstname;
    result.ctcName = item.ctcName;
    result.ctcPhone = item.ctcPhone;
    result.ctcMail = item.ctcMail;
    result.ctcLanguage = item.ctcLanguage;
    return result;
  }
}
